import { render, staticRenderFns } from "./AnswerDenyNapPopup.vue?vue&type=template&id=4a03a6f9&scoped=true"
import script from "./AnswerDenyNapPopup.vue?vue&type=script&lang=js"
export * from "./AnswerDenyNapPopup.vue?vue&type=script&lang=js"
import style0 from "./AnswerDenyNapPopup.vue?vue&type=style&index=0&id=4a03a6f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a03a6f9",
  null
  
)

export default component.exports